module.exports = __webpack_public_path__ + "img/SAC-cns-2019-1.36fca611.png";